import type { Resource } from '../../';
export const country_countries_DK: Resource = {"default":"Denmark"};
